import { useQuery } from "@tanstack/react-query";
import PessoaTipo from "../../Models/Pessoa/PessoaTipo";
import RequestUtilitario, { BasicQueryType } from "../../Utils/RequisicaoUtilitario";
import { Axios } from "../Axios";
import { AxiosResponse } from "axios";
import { EnumPessoaTipo } from "../../Models/Pessoa/Pessoa";
import { useCallback } from "react";

export function useListar({
    pessoaTipo,
    ativo,
    tiposPessoaValidos,
    tiposPessoaInValidos,
    queryKey,
    onSuccess,
    ...reset
}: BasicQueryType<AxiosResponse<PessoaTipo[]>, {
    pessoaTipo?: PessoaTipo,
    ativo?: boolean,
    tiposPessoaValidos?:number[]|EnumPessoaTipo[],
    tiposPessoaInValidos?:number[]|EnumPessoaTipo[],
    onSuccess?:((response:AxiosResponse<PessoaTipo[]>) => void)
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(pessoaTipo ?? {}),
        ativo : ativo
    });

    const mapear = useCallback(({ data }:AxiosResponse<PessoaTipo[]>) => {
        return (data ?? []).filter(f =>  (
                tiposPessoaValidos == null
                || tiposPessoaValidos == undefined
                || tiposPessoaValidos.length == 0 
                || tiposPessoaValidos.some(any => any == f.codigo)
            ) && (
                tiposPessoaInValidos == null
                || tiposPessoaInValidos == undefined
                || tiposPessoaInValidos.length == 0
                || !tiposPessoaInValidos.some(any => any == f.codigo)
            )
        )
        .map(m => {
            m.dataCriacao = new Date(m.dataCriacao);
            return m;
        });
    }, [tiposPessoaValidos, tiposPessoaInValidos]);

    return useQuery({
        ...reset,
        queryKey: [
            "Pessoa.PessoaTipo.Listar", 
            `Pessoa.PessoaTipo.Listar?${queryString}`, 
            "Validos_", (tiposPessoaValidos ?? []).join('_'), 
            "Invalidos_", (tiposPessoaInValidos ?? []).join('_')
        ],
        queryFn : () => Axios.get<PessoaTipo[]>(`pessoa/pessoaTipo?${queryString}`).then(resp => {
            const data = mapear(resp);

            onSuccess?.({
                ...resp,
                data : data
            });

            return resp;
        }),
        select : mapear,
        staleTime : 1000 * 60 * 10 // Ativa por 10 minutos
    });
}


export default {
    useListar
}